import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

const BottomEdgeDivider = ({ className, insetX = 8, thickness = 1, color = '#000000', edge = 'bottom' }) => {
    const style = {
        position: 'absolute',
        left: insetX,
        right: insetX,
        [edge === 'top' ? 'top' : 'bottom']: 0,
        height: thickness,
        display: 'block',
        margin: 0,
        backgroundColor: color,
        pointerEvents: 'none',
    };
    return <Box style={style} className={className || undefined} />;
};

BottomEdgeDivider.propTypes = {
    className: PropTypes.string,
    insetX: PropTypes.number,
    thickness: PropTypes.number,
    color: PropTypes.string,
    edge: PropTypes.oneOf(['top', 'bottom']),
};

export default BottomEdgeDivider;
